module.exports = __webpack_public_path__ + "static/media/22_B.5d3284a7.png";